module.exports = __webpack_public_path__ + "img/bike_black.a26404c2.svg";